// app/components/SearchTrigger.tsx

"use client"

import Image from "next/image"
import { useContext } from "react"

import AppContext from "../AppContext"
import PageThemeContext from "../page-theme/PageThemeContext"

import SearchModal from "./SearchModal"

export default function SearchTrigger() {
  const context = useContext(AppContext)
  const { pageTheme } = useContext(PageThemeContext)
  const isDarkMode = pageTheme.dark
  return (
    <>
      <button
        type="button"
        onClick={() => context.openSearch()}
        className="pl-6"
        aria-label="Open search"
      >
        <span role="img" aria-hidden="true">
          <Image
            alt="search icon"
            height={24}
            width={24}
            src={isDarkMode ? "/icons/Search.svg" : "/icons/Search-light.svg"}
          />
        </span>
      </button>
      <SearchModal
        isOpen={context.searchIsOpen}
        onClose={() => context.closeSearch()}
      />
    </>
  )
}
